var SocialSharing = null;

(function () {
    "use strict";
    
    SocialSharing = {

        counts: { facebook: 0 },
       
        get_counts: function (url) {
            var url2 = null;
            var pos = url.indexOf("?");
            
            if (pos !== -1) {
                url2 = url.substr(0, pos); 
            }
            
            console.log("SocialSharing - Get counts for: " + url);

            jQuery.getScript(window.location.protocol + '//graph.facebook.com/?callback=SocialSharing.update_facebook_count&ids=' + encodeURIComponent(url));
            
            if (url2 !== null) { 
                console.log("SocialSharing - Get extra counts for: " + url2); 
                jQuery.getScript(window.location.protocol + '//graph.facebook.com/?callback=SocialSharing.update_facebook_count&ids=' + encodeURIComponent(url2));
            }

            jQuery.getScript(window.location.protocol + '//www.linkedin.com/countserv/count/share?format=jsonp&callback=SocialSharing.update_linkedin_count&url=' + encodeURIComponent(url));
        },

        update_facebook_count: function (data) {
            if (data) {
                var url = null;

                for (url in data) {
                    if (data[url].share !== undefined && data[url].share.share_count !== undefined) {
                        SocialSharing.counts.facebook += data[url].share.share_count;
                        
                        if (SocialSharing.counts.facebook > 0) {
                            SocialSharing.inject_share_count("#SIFBButton", SocialSharing.counts.facebook);
                        }   
                    }
                }
            }    
        },

        update_linkedin_count: function (data) {
            if (data) {
                if (data.count !== undefined && (data.count * 1) > 0) {
                    SocialSharing.inject_share_count("#SILIButton", data.count);
                }
            }    
        },

        inject_share_count: function (dom_id, count) {
            if ($(".share-count", dom_id).length === 0) {
                $(dom_id).append('<div class="share-count"></div>');
            }
            
            $(".share-count", dom_id).html(SocialSharing.format_count(count));
        },

        format_count: function (count) {
            if (count < 1000) { return count; }
            if (count >= 1000 && count < 10000) { return String(count).substring(0, 1) + 'K+'; }
            return '10K+';
        },

        getanonicallink: function () {
            var itms = $("link");

            for (var x = 0; x < itms.length; x++) {
                if ($(itms[x]).attr("rel").toLowerCase() === "canonical") {
                    return $(itms[x]).attr("href");
                }
            }

            return document.URL;
        },

        enable_email_form: function (val) {
            if (!val) {
                $("input", "#SIEMButtonWnd").attr('disabled', 'disabled');
            }
            else {
                $("input", "#SIEMButtonWnd").removeAttr('disabled');
            }
        },

        check_email_fields: function () {
            var ret = true;

            $("input", "#SIEMButtonWnd").removeClass("error");

            if ($("#target_name").val().length === 0)
            {
                $("#target_name").addClass("error");
                $("#target_name").focus();
                ret = false;
            }
            else if ($("#target_email").val().length === 0) {
                $("#target_email").addClass("error");
                $("#target_email").focus();
                ret = false;
            }
            else if ($("#sender_name").val().length === 0) {
                $("#sender_name").addClass("error");
                $("#sender_name").focus();
                ret = false;
            }
            else if ($("#sender_email").val().length === 0) {
                $("#sender_email").addClass("error");
                $("#sender_email").focus();
                ret = false;
            }

            return ret;
        },

        display_email_message: function (messageobj, error) {
            // Get document language and find message in that language
            var lang = document.documentElement.lang.substr(0,2).toLowerCase();
            var message = 'Unknown message';

            if (messageobj[lang]) {
                message = messageobj[lang];
            }
            else if (messageobj.en) {
                message = messageobj.en;
            }    

            if (error) {
                $("#SIEMFeedback").addClass("error");
                $("#SIEMFeedback").removeClass("success");

                message = "<i class='mdi mdi-alert-circle'></i> " + message;
            }
            else {
                $("#SIEMFeedback").addClass("success");
                $("#SIEMFeedback").removeClass("error");

                message = "<i class='mdi mdi-information'></i> " + message;
            }

            $("#SIEMFeedback").css("display", "block");
            $("#SIEMFeedback").html(message);
        },

        setup_email_sharing: function () {
            $('#SIEMButtonWnd input').on('focus.SocialSharing', function () {
                $('#SIEMButtonWnd .g-recaptcha').css("display", "block");

                $('#SIEMButtonWnd input').off('focus.SocialSharing');
            });

            $('#SIEMButton').click(function () {
                if ($('#SIEMButtonWnd').css("display") === "none") {
                    $('#ShareSocial').addClass("email-open");
                    $('#SIEMButtonWnd').css("opacity", "0");
                    $('#SIEMButtonWnd').css("display", "block");
                    $('#SIEMButtonWnd').animate({ opacity: 1 }, 200);
                }
            });

            $('#SIEMCancel').click(function (event) {
                event.stopPropagation();

                $("#SIEMButtonWnd").css("display", "none");
                $("#ShareSocial").removeClass("email-open");
            });

            $('#SIEMSubmit').click(function () {
                $("#SIEMFeedback").css("display", "none");

                if (!SocialSharing.check_email_fields()) {
                    SocialSharing.display_email_message(SocialSharing.messages.fill_fields, true);
                    return;
                }

                var fdata = $("#SIEMForm").serialize();

                SocialSharing.enable_email_form(false);

                $("#SIEMSubmit").addClass("sending");

                $.ajax({
                    type: "POST",
                    url: "/wp-admin/admin-ajax.php",
                    data: fdata,
                    dataType: 'JSON',
                    success: function (data) {
                        if (data.success) {
                            SocialSharing.display_email_message(SocialSharing.messages.send_success, false);

                            $("#SIEMForm").get(0).reset();
                        }
                        else {
                            if (data.code == "-1") SocialSharing.display_email_message(SocialSharing.messages.send_fail, true);
                            else if (data.code == "-2") {
                                SocialSharing.display_email_message(SocialSharing.messages.invalid_remail, true);
                                $("#target_email").addClass("error");
                                $("#target_email").focus();
                            }
                            else if (data.code == "-3") {
                                SocialSharing.display_email_message(SocialSharing.messages.invalid_semail, true);
                                $("#sender_email").addClass("error");
                                $("#sender_email").focus();
                            }
                            else if (data.code == "-4") SocialSharing.display_email_message(SocialSharing.messages.article_notfound, true);
                            else if (data.code == "-5") SocialSharing.display_email_message(SocialSharing.messages.invalid_captcha, true);
                        }
                    },
                    error: function () {
                        SocialSharing.display_email_message(SocialSharing.messages.send_failnetw, true);
                    },
                    complete: function () {
                        // Reset Google reCaptcha
                        grecaptcha.reset();
                        
                        $("#SIEMSubmit").removeClass("sending");

                        SocialSharing.enable_email_form(true);
                    }
                });

                return false;
            });
        },

        messages: {
            "fill_fields": {
                "en": "Please fill in all fields.",
                "nl": "Vul AUB eerst alle velden in."
            },
            "send_success": {
                "en": "Email successfully sent.",
                "nl": "Email succesvol verstuurd."
            },
            "send_fail": {
                "en": "Email could not be sent.",
                "nl": "Email kon niet verstuurd worden."
            },
            "invalid_remail": {
                "en": "Invalid email address for the receiver.",
                "nl": "Verkeerde email adres voor de ontvanger."
            },
            "invalid_semail": {
                "en": "Invalid email address for the sender.",
                "nl": "Verkeerde email adres voor de zender."
            },
            "article_notfound": {
                "en": "Article not found.",
                "nl": "Artikel niet gevonden."
            },
            "invalid_captcha": {
                "en": "Please fill in the reCaptcha.",
                "nl": "Vul de reCaptcha in."
            },
            "send_failnetw": {
                "en": "Sorry, the email could not be sent. Please try again later.",
                "nl": "Sorry, de email kon niet verstuurd worden. Probeer later opnieuw."
            }
        }        
    };

})();

$(document).ready(function () {
    //SocialSharing.get_counts(SocialSharing.getanonicallink());
    SocialSharing.setup_email_sharing();
});